import React from 'react';
import ReactDOM from 'react-dom/client';
import './helpers/consume_impersonation';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Homepage HTML is the nginx fallback for every URL. Unhide #root only
// after this bundle is about to render the real route.
document.documentElement.removeAttribute('data-wrong-shell');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
